import { graphql, useStaticQuery } from "gatsby";

export default function useLocale() {
  const { site } = useStaticQuery(graphql`
    query SiteMetadataQuery {
      site {
        siteMetadata {
          lang
        }
      }
    }
  `);

  return site.siteMetadata.lang as "ru" | "en";
}
